import { useEffect, useState } from "react";
import api from "@/lib/api";
import { EarningsRows, Totals, thisMonth, eur } from "@/components/app/EarningsTab";

export default function Payroll() {
  const [month, setMonth] = useState(thisMonth());
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get(`/payroll?month=${month}`).then((r) => setD(r.data)); }, [month]);
  return (
    <div className="space-y-6" data-testid="payroll-page">
      <header className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <div className="text-xs uppercase tracking-widest text-sky-600 font-semibold mb-2">Compensi</div>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">Paghe</h1>
          <p className="text-slate-500 mt-2 text-sm">Tariffa oraria × ore del lavoro. Le quote si sbloccano quando segni "Saldo incassato" sul lavoro.</p>
        </div>
        <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="h-11 rounded-md border border-slate-200 px-3 text-sm bg-white" data-testid="payroll-month-input" />
      </header>
      {d && <Totals t={d.totals} />}
      <div className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-100">
        {d?.employees.length === 0 && <div className="p-12 text-center text-slate-400">Nessuna ora sui lavori in questo mese.</div>}
        {d?.employees.map((p) => (
          <div key={p.user_id} className="p-4" data-testid={`payroll-employee-${p.user_id}`}>
            <button onClick={() => setOpen(open === p.user_id ? null : p.user_id)} className="w-full flex flex-wrap items-center gap-3 text-left">
              <span className="flex-1 font-semibold text-slate-900">{p.name} <span className="text-xs font-normal text-slate-500">· {eur(p.hourly_rate)}/h</span></span>
              <span className="text-sm text-slate-500">{p.totals.hours} h</span>
              <span className="text-sm font-semibold text-emerald-700">{eur(p.totals.unlocked)}</span>
              <span className="text-sm font-semibold text-amber-700">{eur(p.totals.frozen)} congelati</span>
            </button>
            {open === p.user_id && <div className="mt-3"><EarningsRows rows={p.rows} /></div>}
          </div>
        ))}
      </div>
    </div>
  );
}
